<mat-menu #userMenu="matMenu" class="rkt-menu header-dropdown">
  @if (showParticipantName()) {
    <div class="participant-info">
      <div class="participant-avatar mobile-avatar">
        {{ participantInitial }}
      </div>
      <span class="participant-name">{{ participantName() }}</span>
    </div>
  }
  @if (showLanguageOption()) {
    <button
      appTrackedButton
      [trackId]="'header:language-selector'"
      [trackType]="'expand'"
      mat-menu-item
      class="rkt-menu__item"
      [matMenuTriggerFor]="languageMenu"
      [title]="'header.LANGUAGE_SELECTOR_TITLE' | translate"
    >
      <nova-icon name="navigate_before"></nova-icon>
      <span>{{ getCurrentLanguageInfo().code.toUpperCase() }}</span>
    </button>
  }
  @if (showPhoneOption()) {
    <button
      appTrackedButton
      [trackId]="'header:call-support'"
      mat-menu-item
      class="rkt-menu__item"
      [title]="'header.CALL_SUPPORT_TITLE' | translate"
      (click)="callSupport()"
    >
      <nova-icon name="phone_in_talk"></nova-icon>
      <span>{{ phoneNumber() }}</span>
    </button>
  }
  <a
    appTrackedLink
    [trackId]="'header:terms'"
    mat-menu-item
    class="rkt-menu__item"
    [routerLink]="['/terms', 'termsofuse']"
    queryParamsHandling="preserve"
    target="_blank"
    rel="noopener noreferrer"
    [title]="'header.MENU.TERMS_OF_USE' | translate"
  >
    <nova-icon name="summarize"></nova-icon>
    <span>{{ "header.MENU.TERMS_OF_USE" | translate }}</span>
  </a>
  <a
    appTrackedLink
    [trackId]="'header:privacy-policy'"
    mat-menu-item
    class="rkt-menu__item"
    [routerLink]="['/terms', 'privacypolicy']"
    queryParamsHandling="preserve"
    target="_blank"
    rel="noopener noreferrer"
    [title]="'header.MENU.PRIVACY_POLICY' | translate"
  >
    <nova-icon name="security"></nova-icon>
    <span>{{ "header.MENU.PRIVACY_POLICY" | translate }}</span>
  </a>
  @if (showExitSigning()) {
    <div class="sign-out-container">
      <button
        novaButton
        appTrackedButton
        [trackId]="'header:exit-signing'"
        [trackType]="'sign_out'"
        variant="primary"
        [title]="'header.EXIT_SIGNING' | translate"
        (click)="exitSigning()"
        class="sign-out-button"
      >
        {{ "header.EXIT_SIGNING" | translate }}
      </button>
    </div>
  }
</mat-menu>
<mat-menu
  #languageMenu="matMenu"
  class="rkt-menu language-submenu"
  yPosition="above"
>
  @for (language of availableLanguages; track language.code) {
    <button
      appTrackedButton
      [trackId]="`header:language-selector:${language.code}`"
      mat-menu-item
      class="rkt-menu__item"
      [title]="('header.LANGUAGE_SELECT_TITLE' | translate: {languageName: language.name})"
      (click)="selectLanguage(language)"
    >
      <span>{{ language.name }}</span>
      @if (language.code === currentLanguage()) {
        <span> ✓</span>
      }
    </button>
  }
</mat-menu>
